import * as React from 'react';

import { cva, VariantProps } from 'class-variance-authority';
import { OmitStylesComponentProps } from '../../types';

const paginationContentVariants = cva('rocco-pagination-content', {
    variants: {
        variant: {
            default: 'flex flex-row items-center gap-2',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

export const PaginationContent = React.forwardRef<
    HTMLUListElement,
    OmitStylesComponentProps<'ul'> &
        VariantProps<typeof paginationContentVariants>
>(({ variant, ...props }, ref) => (
    <ul
        ref={ref}
        className={paginationContentVariants({ variant })}
        {...props}
    />
));

PaginationContent.displayName = 'PaginationContent';
